const initialState = {
  isOpen: false,
  userId: null,
  fullName: '',
  isOwnPassword: false,
  saveStatus: 'idle',
};

export default initialState;
